import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"
import { Link } from "gatsby"
import Carousel from "../../molecules/carousel"
import { Grid } from "../../atoms/grid"
import { Settings } from "../../../styles/theme"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

const Cardstyle = styled.div`
  position: relative;
  > .full-margin {
    margin: 1rem;
    > div {
      margin: 1rem auto;
      position: relative;
      max-width: 300px;
      transition: all 175ms ease-in-out;
      cursor: pointer;
      &:hover {
        transform: scale(1.05);
        box-shadow: 5px 5px 8px #00000084;
      }
    }
  }
  a > div {
    margin: 1rem auto;
    position: relative;
    max-width: ${props => (props.fullWidth ? "none" : "300px")};
    transition: all 175ms ease-in-out;
    cursor: pointer;
    &:hover {
      transform: scale(1.05);
      box-shadow: 5px 5px 8px #00000084;
    }
  }
  .gatsby-image-wrapper,
  .grey {
    position: relative !important;
    top: 0;
    left: 0;
    width: 100%;
    height: 350px;
    z-index: 0;
  }
  .grey {
    height: 350px;
    background: rgba(0, 0, 0, 0.4);
  }
  .content {
    position: absolute;
    z-index: 2;
    bottom: 0;
    width: 100%;
    text-align: center;
    h6 {
      color: #fff;
      font-weight: 700;
      margin-bottom: 0;
      padding-bottom: 1rem;
    }
    p {
      color: #fff;
    }
    .bg {
      position: absolute;
      width: 100%;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0));
      height: 100%;
      top: 0;
      left: 0;
      z-index: -1;
    }
    .text {
      margin: 1rem;
    }
  }
  .popup {
    position: fixed;
    height: 100vh;
    width: 100vw;
    z-index: 999;
    left: 0;
    top: 0;
    pointer-events: none;
    opacity: 0;
    @media screen and (max-width: ${Settings.sizeM}) {
      .gatsby-image-wrapper {
        height: auto !important;
      }
    }
    .background-layer {
      position: absolute;
      z-index: 5;
      background: rgba(0, 0, 0, 0.3);
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
    }
    .close {
      position: sticky;
      z-index: 1000;
      top: 1rem;
      left: 96%;
      font-weight: 700;
      cursor: pointer;
      color: ${Settings.secondaryColor};
    }
    > div {
      background: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 80%;
      max-height: 80vh;
      overflow-y: scroll;
      z-index: 10;
    }
    h3 {
      font-size: 1.5rem;
      color: ${Settings.primaryColor};
    }
    h4 {
      color: ${Settings.secondaryColor};
      margin: 0;
      font-size: 1.2rem;
    }
    .popupContent {
      padding: 3.5rem 0;
      height: 100%;
    }
    .grid-wrapper {
      display: flex;
      > div {
        align-items: stretch;
      }
    }
  }
  .popup.show {
    opacity: 1;
    pointer-events: all;
  }
`

export const Card = ({ object }) => (
  <Cardstyle>
    <Link to={"newsbyte/" + object.title.replace(/\s+/g, "-").toLowerCase()}>
      <div>
        {object.banner ? (
          <Img fluid={object.banner.fluid} />
        ) : (
          <div className="grey" />
        )}
        <div className="content">
          <div className="bg" />
          <div className="text">
            <h6>{object.title}</h6>
            <p>{object.publishedDate}</p>
          </div>
        </div>
      </div>
    </Link>
  </Cardstyle>
)

export const FullCard = ({ object, centered, fullWidth, external }) => (
  <Cardstyle fullWidth={fullWidth}>
    <div className="full-margin">
      {object.slug ? (
        external ? (
          <a href={object.slug} target="_blank">
            <div>
              {object.image ? (
                <Img fluid={object.image.fluid} />
              ) : (
                <div className="grey" />
              )}
              <div className="content">
                <div className="bg" />
                <div className="text">
                  <h6
                    style={
                      centered ? { textAlign: "center" } : { textAlign: "left" }
                    }
                  >
                    {object.title}
                  </h6>
                </div>
              </div>
            </div>
          </a>
        ) : (
          <Link to={object.slug}>
            <div>
              {object.image ? (
                <Img fluid={object.image.fluid} />
              ) : (
                <div className="grey" />
              )}
              <div className="content">
                <div className="bg" />
                <div className="text">
                  <h6
                    style={
                      centered ? { textAlign: "center" } : { textAlign: "left" }
                    }
                  >
                    {object.title}
                  </h6>
                </div>
              </div>
            </div>
          </Link>
        )
      ) : (
        <div>
          {object.image ? (
            <Img fluid={object.image.fluid} />
          ) : (
            <div className="grey" />
          )}
          <div className="content">
            <div className="bg" />
            <div className="text">
              <h6
                style={
                  centered ? { textAlign: "center" } : { textAlign: "left" }
                }
              >
                {object.title}
              </h6>
            </div>
          </div>
        </div>
      )}
    </div>
  </Cardstyle>
)

export const FullCardWithPopup = ({
  object,
  selected,
  toggle,
  setSelected,
  togglePopup,
  thisCard,
}) => (
  <Cardstyle>
    <div className="full-margin">
      <div
        onClick={() => {
          setSelected(thisCard)
          togglePopup()
        }}
      >
        {object.images ? (
          <Img fluid={object.images[0].fluid} />
        ) : (
          <div className="grey" />
        )}
        <div className="content">
          <h6>{object.title}</h6>
        </div>
      </div>
    </div>
    <div className={toggle && selected === thisCard ? "popup show" : "popup"}>
      <span
        className="background-layer"
        onClick={() => {
          togglePopup()
        }}
      />
      <div className="grid-wrapper">
        <span
          className="close"
          onClick={() => {
            togglePopup()
          }}
        >
          X
        </span>
        <Grid columns={2}>
          <div>
            <div style={{ padding: "2rem" }}>
              <h3>{object.title}</h3>
              <Carousel slide={1} noArrows>
                {object.images.length > 1
                  ? object.images.slice(1).map((img, i) => (
                      <div key={i}>
                        <Img fluid={img.fluid} />
                      </div>
                    ))
                  : object.images.map((img, i) => (
                      <div key={i}>
                        <Img fluid={img.fluid} />
                      </div>
                    ))}
              </Carousel>
              <div style={{ marginTop: "5rem" }}>
                {documentToReactComponents(object.shortDescription.json)}
              </div>
            </div>
          </div>
          <div>
            {object.content ? (
              <div className="constraint popupContent">
                {documentToReactComponents(object.content.json)}
              </div>
            ) : (
              ""
            )}
          </div>
        </Grid>
      </div>
    </div>
  </Cardstyle>
)
